import { TypographyV2 } from "components/v2/components/common"

const GuidelineCard = ({ description }: { description: string }) => {
    return (
        <div className="flex flex-col items-start justify-center gap-[24px] bg-white rounded-lg p-4 w-full">
            <TypographyV2 type="base">{description}</TypographyV2>
        </div>
    )
}

export default GuidelineCard
